import FormLayout from '../FormLayout/FormLayout'

import './FormAstronaut.scss'

const FormAstronaut = ({ className }) => {
    return (
        <FormLayout
            className={`form-astronaut position-relative d-flex justify-content-center align-items-center ${className}`}
            color={'transparent'}
        >
            <img
                className={'form-astronaut--img position-absolute w-auto astronaut-animate '}
                src={'images/cinestar/astronaut-with-mobile.png'}
                alt={'astronaut-with-mobile'}
            />
        </FormLayout>
    )
}

export default FormAstronaut
